import { format as formatDate } from 'date-fns';
import {
  formatHumanReadableNumber,
  formatMoney,
} from 'helpers/formatters/number';
import React from 'react';
import { USD } from 'store/Currency/types';

import {
  Container,
  DateValue,
  Item,
  Label,
  PriceValue,
  VolumeValue,
} from './styles';

interface Payload {
  payload: {
    date: number;
    price: number;
    volume: number | null;
  };
}

interface Props {
  active: boolean;
  payload?: Payload[];
  coinCode: string;
}

const Tooltip = (props: any) => {
  const { payload, active } = props as Props;

  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const dataPoint = payload[0].payload;

  return (
    <Container>
      <ul>
        <Item>
          <DateValue>
            {formatDate(new Date(dataPoint.date), 'EEE, MMM dd yyyy, kk:mm:ss')}
          </DateValue>
        </Item>
        <Item>
          <Label>Price: </Label>
          <PriceValue>{formatMoney(dataPoint.price)}</PriceValue>
        </Item>
        {dataPoint.volume !== null && (
          <Item>
            <Label>Volume: </Label>
            <VolumeValue>
              {formatHumanReadableNumber(
                dataPoint.volume * dataPoint.price,
                USD,
              )}
            </VolumeValue>
          </Item>
        )}
      </ul>
    </Container>
  );
};

export default Tooltip;
